<template>
  <div class="home">
    <app-sidebar></app-sidebar>

    <!-- Shop by category section -->
    <div class="wrapper-content">
      <app-header></app-header>

      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>
            Select Option to Pay
            <span>₹ 250</span>
          </h2>
        </div>
      </div>

      <div class="paymentDetails">
        <div class="container">
          <div class="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2">
            <ul class="cardsList">
              <li class="panel">
                <div class="cardListTItle">
                  <input id="tbalance" type="radio" v-model="x" value="tbalance" checked />
                  <label for="tbalance">
                    Trakop Balance
                    <span>₹ 250</span>
                  </label>
                </div>
                <div class="DataForm" v-show="x === 'tbalance'">
                  <form
                    role="form"
                    action="/my-order"
                    class="input-animation forminner removePadding"
                    id="payment-form"
                  >
                    <div class="row">
                      <div class="col-sm-12">
                        <b-button class="btn btn-primary btn-block" v-b-modal.modal-1>Pay ₹250</b-button>
                      </div>
                    </div>
                    <div class="row" style="display:none;">
                      <div class="col-sm-12">
                        <p class="payment-errors"></p>
                      </div>
                    </div>
                  </form>
                </div>
              </li>
              <li class="panel">
                <div class="cardListTItle">
                  <input id="dabitCard" type="radio" v-model="x" value="dabitCard" />
                  <label for="dabitCard">Debit Card</label>
                </div>
                <div class="DataForm" v-show="x === 'dabitCard'">
                  <form
                    role="form"
                    action="/my-order"
                    class="input-animation forminner"
                    id="payment-form"
                  >
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group input-field">
                          <div class="input-group">
                            <input
                              type="tel"
                              class="form-control"
                              name="cardNumber"
                              autocomplete="cc-number"
                              required
                            />
                            <label for="cardNumber">Enter Card Number</label>
                            <span class="input-group-addon">
                              <i class="fa fa-credit-card"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-7 col-md-7">
                        <div class="form-group input-field">
                          <input
                            type="tel"
                            class="form-control"
                            name="cardExpiry"
                            autocomplete="cc-exp"
                            required
                          />
                          <label for="cardExpiry">Expiry Date</label>
                        </div>
                      </div>
                      <div class="col-xs-5 col-md-5 pull-right">
                        <div class="form-group input-field">
                          <input
                            type="tel"
                            class="form-control"
                            name="cardCVC"
                            autocomplete="cc-csc"
                            required
                          />
                          <label for="cardCVC">CVV</label>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <router-link to="/my-order" class="btn btn-primary btn-block">Pay ₹250</router-link>
                      </div>
                    </div>
                    <div class="row" style="display:none;">
                      <div class="col-sm-12">
                        <p class="payment-errors"></p>
                      </div>
                    </div>
                  </form>
                </div>
              </li>
              <li class="panel">
                <div class="cardListTItle">
                  <input id="creditCard" type="radio" v-model="x" value="creditCard" />
                  <label for="creditCard">Credit Card</label>
                </div>
                <div class="DataForm" v-show="x === 'creditCard'">
                  <form
                    role="form"
                    action="/my-order"
                    class="input-animation forminner"
                    id="payment-form"
                  >
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group input-field">
                          <div class="input-group">
                            <input
                              type="tel"
                              class="form-control"
                              name="cardNumber"
                              autocomplete="cc-number"
                              required
                            />
                            <label for="cardNumber">Enter Card Number</label>
                            <span class="input-group-addon">
                              <i class="fa fa-credit-card"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-7 col-md-7">
                        <div class="form-group input-field">
                          <input
                            type="tel"
                            class="form-control"
                            name="cardExpiry"
                            autocomplete="cc-exp"
                            required
                          />
                          <label for="cardExpiry">Expiry Date</label>
                        </div>
                      </div>
                      <div class="col-xs-5 col-md-5 pull-right">
                        <div class="form-group input-field">
                          <input
                            type="tel"
                            class="form-control"
                            name="cardCVC"
                            autocomplete="cc-csc"
                            required
                          />
                          <label for="cardCVC">CVV</label>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <router-link to="/my-order" class="btn btn-primary btn-block">Pay ₹250</router-link>
                      </div>
                    </div>
                    <div class="row" style="display:none;">
                      <div class="col-sm-12">
                        <p class="payment-errors"></p>
                      </div>
                    </div>
                  </form>
                </div>
              </li>
              <li class="panel">
                <div class="cardListTItle">
                  <input id="netBanking" type="radio" v-model="x" value="netBanking" />
                  <label for="netBanking">Net Banking</label>
                </div>
                <div class="DataForm" v-show="x === 'netBanking'">
                  <ul class="banksList">
                    <li>
                      <div class="cardListTItle">
                        <input id="iciciBank" type="radio" v-model="y" value="iciciBank" />
                        <label for="iciciBank">ICICI Bank</label>
                      </div>
                      <div class="DataForm" v-show="y === 'iciciBank'">
                        <form
                          role="form"
                          action="/my-order"
                          class="input-animation forminner removePadding"
                          id="payment-form"
                        >
                          <div class="row">
                            <div class="col-sm-12">
                              <router-link to="/my-order" class="btn btn-primary btn-block">Pay ₹250</router-link>
                            </div>
                          </div>
                        </form>
                      </div>
                    </li>
                    <li>
                      <div class="cardListTItle">
                        <input id="indusind" type="radio" v-model="y" value="indusind" />
                        <label for="indusind">Indusind Bank</label>
                      </div>
                      <div class="DataForm" v-show="y === 'indusind'">
                        <form
                          role="form"
                          class="input-animation forminner removePadding"
                          id="payment-form"
                        >
                          <div class="row">
                            <div class="col-sm-12">
                              <router-link to="/my-order" class="btn btn-primary btn-block">Pay ₹250</router-link>
                            </div>
                          </div>
                        </form>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="panel">
                <div class="cardListTItle">
                  <input id="cod" type="radio" v-model="x" value="cod" />
                  <label for="cod">Cash On Delivery</label>
                </div>
                <div class="DataForm" v-show="x === 'cod'">
                  <form
                    role="form"
                    action="/my-order"
                    class="input-animation forminner removePadding"
                    id="payment-form"
                  >
                    <div class="row">
                      <div class="col-sm-12">
                        <router-link to="/my-order" class="btn btn-primary btn-block">Proceed</router-link>
                      </div>
                    </div>
                    <div class="row" style="display:none;">
                      <div class="col-sm-12">
                        <p class="payment-errors"></p>
                      </div>
                    </div>
                  </form>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- <div class="addMoney">
        <div class="container">
            <div class="addMoneyContainer">   
                <div class="walletBalance">Wallet Balance <span>₹0.00</span></div>
                <form class="input-animation addMoneyForm" action="/wallet">
                    <div class="form-group input-field">                        
                        <input id="amount" type="text" name="amount" class="form-control" required>
                        <label for="amount">Enter Amount (₹)</label>
                    </div>
                    <div class="form-group promocode">
                        
                            <input id="promocode" type="text" name="amount" class="form-control" value="">
                            <label for="promocode">Apply Promocode</label>
                            <button class="btn btn-primary applyPromoBtn">Apply</button>
                    </div>
                    <div class="form-group">
                        <Ul class="radioBtns">
                            <li>
                                <input type="radio" name="paymentMethod" id="paytm" checked >
                                <label for="paytm"><img src="../assets/images/paytm.png" > Paytm/Net Banking/Credit and Debit Card</label>
                            </li>
                            <li>
                                <input type="radio" name="paymentMethod" id="payUMoney">
                                <label for="payUMoney"><img src="../assets/images/payU.png" > PayU Money</label>
                            </li>
                            <li>
                                <input type="radio" name="paymentMethod" id="paypal">
                                <label for="paypal"><img src="../assets/images/paypal.png" > Paypal</label>
                            </li>
                        </Ul>
                    </div>
                    <div class="addMoneyBtn">
                        <button class="btn btn-primary">Add Money</button>
                    </div>
                </form>  
            </div>
            
        </div>
      </div>-->
    </div>

  <b-modal id="modal-1" hide-header hide-footer>
    <div class="text-center productConfirmed">
      <img src="../assets/images/tick.svg" alt="" width="50" height="50">
      <h4>Awesome !</h4>
      <p>Your product has been confirmed.</p>
      <span>Order id :- 3326</span>

      <router-link to="/home" class="backHomeBtn">Back to home</router-link>
    </div>
  </b-modal>
    <div ref="parentSidebar" id="parentx">
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default {
  name: "Add Money",

  components: {
    "app-header": Header,
    "app-sidebar": Sidebar,
    "app-footer": Footer
    // HelloWorld
  },
  data() {
    return {
      x: "tbalance",
      y: ""
    };
  }
};
</script>
